/**
 * Release date of the "new users" restrictions for the login-edu widget.
 *
 * Every login-edu widget of an account created on or after this date renders without the
 * sign-in flow. Nothing is stored on the widget: the account date is read at render time —
 * `memberAreaUser.createdAt` in the editor, the site owner's `user.createdAt` of `/soa/build`
 * on the published site.
 *
 * NOTE: change this value manually whenever the actual release date needs to be adjusted.
 */
export const LOGIN_EDU_NEW_USER_RELEASE_DATE = '2026-10-13T00:00:00.000Z';

/**
 * Whether an account created at `userCreatedAt` is a "new" one — created on or after
 * {@link LOGIN_EDU_NEW_USER_RELEASE_DATE}.
 *
 * Returns `false` when the creation date is missing or unparsable, so that anything we are
 * not sure about (old users, missing user context) keeps the previous, unrestricted behavior.
 */
export function isLoginEduNewUser(userCreatedAt?: string | null): boolean {
    if (!userCreatedAt) {
        return false;
    }

    // `ma_RegDate` may come as a zone-less MySQL `Y-m-d H:i:s`, which Safari cannot parse and
    // Node and browsers would read in different local zones — the SSR render and the hydrated
    // page must agree, so a zone-less value is read as UTC.
    const isoCreatedAt = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(userCreatedAt)
        ? `${userCreatedAt.replace(' ', 'T')}Z`
        : userCreatedAt;
    const createdAtTime = new Date(isoCreatedAt).getTime();

    if (Number.isNaN(createdAtTime)) {
        return false;
    }

    return createdAtTime >= new Date(LOGIN_EDU_NEW_USER_RELEASE_DATE).getTime();
}
